(function () {
  function initHeroArchiveProjectSlider() {
    if (typeof Swiper === "undefined") return;

    document
      .querySelectorAll(".hero-archive-project-swiper")
      .forEach((swiperContainer) => {
        if (swiperContainer.dataset.swiperInitialized === "true") return;

        swiperContainer.dataset.swiperInitialized = "true";

        new Swiper(swiperContainer, {
          slidesPerView: 1,
          spaceBetween: 0,
          loop: true,
          allowTouchMove: false,
          speed: 1750,
          autoplay: {
            delay: 5000,
          },
        });
      });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initHeroArchiveProjectSlider);
  } else {
    initHeroArchiveProjectSlider();
  }

  document.addEventListener(
    "shopify:section:load",
    initHeroArchiveProjectSlider,
  );
})();
